// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TextField / TextArea Component Styles */

:root {
  --scl--cms-components-textField-border-color: var(--input-defualt);
  --scl--cms-components-textField-border-hover-color: var(--input-hover);
  --scl--cms-components-textField-focus-color: #2388FF;
  --scl--cms-components-textField-warning-color: #FFC18E;
  --scl--cms-components-textField-error-color: #F8868A;
  --scl--cms-components-textField-text-color: var(--input-hover);
  --scl--cms-components-textField-label-color: var(--input-defualt);
  --scl--cms-components-textField-label-hover-color: var(--input-hover);
  --scl--cms-components-textField-label-floating-bg: linear-gradient(108.2deg, #E9F0F8 0%, #FAFBFC 41.13%, #E9F0F8 96.11%);
  --scl--cms-components-textField-required-color: #EB5252;
  --scl--cms-components-textField-assistive-text-color: rgba(255, 255, 255, 0.54);
  --scl--cms-components-textField-assistive-error-color: #FF5252;
  --scl--cms-components-textField-assistive-warning-color: #FFC18E;
}

/* Container */
.scl--cms-components-textField-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  position: relative;
}

/* Plate (the visible input border wrapper) */
.scl--cms-components-textField-plate {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  border: 1px solid var(--scl--cms-components-textField-border-color);
  border-radius: 3px;
  cursor: text;
  transition: border-color 0.3s ease;
  position: relative;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  background: transparent;
}

/* Single-line height */
.scl--cms-components-textField-plate:not(.scl--cms-components-textField--multiline) {
  height: 38px;
}

/* Multi-line min height */
.scl--cms-components-textField-plate.scl--cms-components-textField--multiline {
  min-height: 80px;
  height: auto;
  align-items: stretch;
  cursor: text;
}

/* Bottom accent bar */
.scl--cms-components-textField-plate::after {
  content: '';
  position: absolute;
  left: -1px;
  bottom: -1px;
  width: calc(100% + 2px);
  height: 4px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  background: var(--scl--cms-components-textField-focus-color);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.scl--cms-components-textField-plate.scl--cms-components-textField--focused::after {
  opacity: 1;
}

.scl--cms-components-textField-plate:hover:not(.scl--cms-components-textField--focused) {
  border-color: var(--scl--cms-components-textField-border-hover-color);
}

.scl--cms-components-textField-plate.scl--cms-components-textField--focused {
  border-color: var(--scl--cms-components-textField-border-hover-color);
}

.scl--cms-components-textField-plate.scl--cms-components-textField--warning::after {
  background: var(--scl--cms-components-textField-warning-color);
  opacity: 1;
}

.scl--cms-components-textField-plate.scl--cms-components-textField--error::after {
  background: var(--scl--cms-components-textField-error-color);
  opacity: 1;
}

.scl--cms-components-textField-plate.scl--cms-components-textField--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Inner wrapper */
.scl--cms-components-textField-wrapper {
  display: flex;
  flex-direction: row;

  align-items: center;
  padding: 0px 12px;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  order: 0;
  flex-grow: 1;
}

.scl--cms-components-textField-plate.scl--cms-components-textField--multiline .scl--cms-components-textField-wrapper {
  align-items: flex-start;
  padding: 8px 12px;
}

/* Input */
.scl--cms-components-textField-input {
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.25px;
  caret-color: var(--input-hover);
  color: var(--scl--cms-components-textField-text-color);
  padding: 0;
  flex: 1;
  order: 0;
  flex-grow: 1;
  min-height: 38px;
  box-sizing: border-box;
}

/* Textarea specific */
.scl--cms-components-textField-input.scl--cms-components-textField-input--textarea {
  resize: vertical;
  min-height: 64px;
  line-height: 22px;
  padding-top: 2px;
}

.scl--cms-components-textField-input::placeholder {
  color: transparent;
}

.scl--cms-components-textField-input:disabled {
  cursor: not-allowed;
}

/* Floating Label */
.scl--cms-components-textField-label {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--scl--cms-components-textField-label-color);
  background: transparent;
  padding: 0 2px;
  margin: 0 -2px;
  pointer-events: none;
  transition: all 0.2s ease;
  z-index: 1;
  opacity: 1;
}

/* Multiline: anchor label to top of plate */
.scl--cms-components-textField-plate.scl--cms-components-textField--multiline .scl--cms-components-textField-label {
  top: 16px;
}

.scl--cms-components-textField-label.scl--cms-components-textField-label--floating {
  top: 0;
  left: 12px;
  transform: translateY(-50%);
  font-size: 12px;
  line-height: 16px;
  color: var(--typography-text-body-secondary);
  padding: 0 6px;
  margin: 0 -6px;
  background: transparent;
  position: absolute;
  z-index: 2;
}

.scl--cms-components-textField-label.scl--cms-components-textField-label--floating::before {
  content: "";
  position: absolute;
  left: 4px;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  height: 2px;
  background: #F5F8FB;
  /* same as your container */
  z-index: -1;
}

/* Hover label color */
.scl--cms-components-textField-plate:hover:not(.scl--cms-components-textField--focused) .scl--cms-components-textField-label {
  color: var(--typography-text-body-secondary);
}

/* Required asterisk */
.scl--cms-components-textField-requiredAsterisk {
  color: var(--scl--cms-components-textField-required-color);
}

.scl--cms-components-textField-plate:hover:not(.scl--cms-components-textField--focused) .scl--cms-components-textField-requiredAsterisk {
  color: var(--scl--cms-components-textField-required-color);
}

/* Assistive / Error text */
.scl--cms-components-textField-assistive {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 4px 0px 14px;
  min-height: 16px;
  font-family: var(--scl--default-font);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: -0.15px;
  color: var(--scl--cms-components-textField-assistive-text-color);
  width: 100%;
  box-sizing: border-box;
}

.scl--cms-components-textField-assistive.scl--cms-components-textField-assistive--error {
  color: var(--scl--cms-components-textField-assistive-error-color);
}

.scl--cms-components-textField-assistive.scl--cms-components-textField-assistive--warning {
  color: var(--scl--cms-components-textField-assistive-warning-color);
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/input-fs-cp/text-field-op/css/textField.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,kEAAkE;EAClE,sEAAsE;EACtE,oDAAoD;EACpD,sDAAsD;EACtD,oDAAoD;EACpD,8DAA8D;EAC9D,iEAAiE;EACjE,qEAAqE;EACrE,wHAAwH;EACxH,uDAAuD;EACvD,+EAA+E;EAC/E,8DAA8D;EAC9D,gEAAgE;AAClE;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;;EAEX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mEAAmE;EACnE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;EAC/B,4DAA4D;EAC5D,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,8DAA8D;EAC9D,UAAU;AACZ;;AAEA;EACE,4DAA4D;EAC5D,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;;EAEnB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,sDAAsD;EACtD,UAAU;EACV,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,uDAAuD;EACvD,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,UAAU;EACV,UAAU;AACZ;;AAEA,4CAA4C;AAC5C;EACE,SAAS;AACX;;AAEA;EACE,MAAM;EACN,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gEAAgE;EAChE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,mEAAmE;AACrE","sourcesContent":["/* TextField / TextArea Component Styles */\n\n:root {\n  --scl--cms-components-textField-border-color: var(--input-defualt);\n  --scl--cms-components-textField-border-hover-color: var(--input-hover);\n  --scl--cms-components-textField-focus-color: #2388FF;\n  --scl--cms-components-textField-warning-color: #FFC18E;\n  --scl--cms-components-textField-error-color: #F8868A;\n  --scl--cms-components-textField-text-color: var(--input-hover);\n  --scl--cms-components-textField-label-color: var(--input-defualt);\n  --scl--cms-components-textField-label-hover-color: var(--input-hover);\n  --scl--cms-components-textField-label-floating-bg: linear-gradient(108.2deg, #E9F0F8 0%, #FAFBFC 41.13%, #E9F0F8 96.11%);\n  --scl--cms-components-textField-required-color: #EB5252;\n  --scl--cms-components-textField-assistive-text-color: rgba(255, 255, 255, 0.54);\n  --scl--cms-components-textField-assistive-error-color: #FF5252;\n  --scl--cms-components-textField-assistive-warning-color: #FFC18E;\n}\n\n/* Container */\n.scl--cms-components-textField-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  width: 100%;\n\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  position: relative;\n}\n\n/* Plate (the visible input border wrapper) */\n.scl--cms-components-textField-plate {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  width: 100%;\n  border: 1px solid var(--scl--cms-components-textField-border-color);\n  border-radius: 3px;\n  cursor: text;\n  transition: border-color 0.3s ease;\n  position: relative;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  background: transparent;\n}\n\n/* Single-line height */\n.scl--cms-components-textField-plate:not(.scl--cms-components-textField--multiline) {\n  height: 38px;\n}\n\n/* Multi-line min height */\n.scl--cms-components-textField-plate.scl--cms-components-textField--multiline {\n  min-height: 80px;\n  height: auto;\n  align-items: stretch;\n  cursor: text;\n}\n\n/* Bottom accent bar */\n.scl--cms-components-textField-plate::after {\n  content: '';\n  position: absolute;\n  left: -1px;\n  bottom: -1px;\n  width: calc(100% + 2px);\n  height: 4px;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  background: var(--scl--cms-components-textField-focus-color);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.scl--cms-components-textField-plate.scl--cms-components-textField--focused::after {\n  opacity: 1;\n}\n\n.scl--cms-components-textField-plate:hover:not(.scl--cms-components-textField--focused) {\n  border-color: var(--scl--cms-components-textField-border-hover-color);\n}\n\n.scl--cms-components-textField-plate.scl--cms-components-textField--focused {\n  border-color: var(--scl--cms-components-textField-border-hover-color);\n}\n\n.scl--cms-components-textField-plate.scl--cms-components-textField--warning::after {\n  background: var(--scl--cms-components-textField-warning-color);\n  opacity: 1;\n}\n\n.scl--cms-components-textField-plate.scl--cms-components-textField--error::after {\n  background: var(--scl--cms-components-textField-error-color);\n  opacity: 1;\n}\n\n.scl--cms-components-textField-plate.scl--cms-components-textField--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Inner wrapper */\n.scl--cms-components-textField-wrapper {\n  display: flex;\n  flex-direction: row;\n\n  align-items: center;\n  padding: 0px 12px;\n  gap: 8px;\n  width: 100%;\n  box-sizing: border-box;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n}\n\n.scl--cms-components-textField-plate.scl--cms-components-textField--multiline .scl--cms-components-textField-wrapper {\n  align-items: flex-start;\n  padding: 8px 12px;\n}\n\n/* Input */\n.scl--cms-components-textField-input {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  caret-color: var(--input-hover);\n  color: var(--scl--cms-components-textField-text-color);\n  padding: 0;\n  flex: 1;\n  order: 0;\n  flex-grow: 1;\n  min-height: 38px;\n  box-sizing: border-box;\n}\n\n/* Textarea specific */\n.scl--cms-components-textField-input.scl--cms-components-textField-input--textarea {\n  resize: vertical;\n  min-height: 64px;\n  line-height: 22px;\n  padding-top: 2px;\n}\n\n.scl--cms-components-textField-input::placeholder {\n  color: transparent;\n}\n\n.scl--cms-components-textField-input:disabled {\n  cursor: not-allowed;\n}\n\n/* Floating Label */\n.scl--cms-components-textField-label {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  color: var(--scl--cms-components-textField-label-color);\n  background: transparent;\n  padding: 0 2px;\n  margin: 0 -2px;\n  pointer-events: none;\n  transition: all 0.2s ease;\n  z-index: 1;\n  opacity: 1;\n}\n\n/* Multiline: anchor label to top of plate */\n.scl--cms-components-textField-plate.scl--cms-components-textField--multiline .scl--cms-components-textField-label {\n  top: 16px;\n}\n\n.scl--cms-components-textField-label.scl--cms-components-textField-label--floating {\n  top: 0;\n  left: 12px;\n  transform: translateY(-50%);\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--typography-text-body-secondary);\n  padding: 0 6px;\n  margin: 0 -6px;\n  background: transparent;\n  position: absolute;\n  z-index: 2;\n}\n\n.scl--cms-components-textField-label.scl--cms-components-textField-label--floating::before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  right: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 2px;\n  background: #F5F8FB;\n  /* same as your container */\n  z-index: -1;\n}\n\n/* Hover label color */\n.scl--cms-components-textField-plate:hover:not(.scl--cms-components-textField--focused) .scl--cms-components-textField-label {\n  color: var(--typography-text-body-secondary);\n}\n\n/* Required asterisk */\n.scl--cms-components-textField-requiredAsterisk {\n  color: var(--scl--cms-components-textField-required-color);\n}\n\n.scl--cms-components-textField-plate:hover:not(.scl--cms-components-textField--focused) .scl--cms-components-textField-requiredAsterisk {\n  color: var(--scl--cms-components-textField-required-color);\n}\n\n/* Assistive / Error text */\n.scl--cms-components-textField-assistive {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 4px 4px 0px 14px;\n  min-height: 16px;\n  font-family: var(--scl--default-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: -0.15px;\n  color: var(--scl--cms-components-textField-assistive-text-color);\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.scl--cms-components-textField-assistive.scl--cms-components-textField-assistive--error {\n  color: var(--scl--cms-components-textField-assistive-error-color);\n}\n\n.scl--cms-components-textField-assistive.scl--cms-components-textField-assistive--warning {\n  color: var(--scl--cms-components-textField-assistive-warning-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
